import script from "./CustomSigningRoom.vue?vue&type=script&lang=js"
export * from "./CustomSigningRoom.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./CustomSigningRoom.vue?vue&type=custom&index=0&blockType=div"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__